import Auth from "@/Auth";

const COUNTRY_STORAGE_KEY = "country"; // Key for localStorage

const state = {
  country_code: localStorage.getItem(COUNTRY_STORAGE_KEY) || null, // Initialize from localStorage
  isLoading: false,
};

const mutations = {
  SET_COUNTRY_CODE(state, country_code) {
    state.country_code = country_code || null;
    // Persist to localStorage (remove if null)
    if (country_code) {
      localStorage.setItem(COUNTRY_STORAGE_KEY, country_code);
    } else {
      localStorage.removeItem(COUNTRY_STORAGE_KEY);
    }
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const actions = {
  async fetchCountryViaIpAddress({ commit, state }) {
    // Skip API call if already in localStorage
    if (state.country_code) return;

    commit("SET_LOADING", true);
    try {
      const countryCode = await Auth.getCountry();
      if (countryCode) {
        commit("SET_COUNTRY_CODE", countryCode);
      }
    } catch (error) {
      console.error("Failed to fetch country:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const getters = {
  countryCode: (state) => state.country_code,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
